module.exports = __webpack_public_path__ + "resources/img/img-company-aboutteam@2x.78bd2281.png";